import { render, staticRenderFns } from "./SaleEditMultiStudentsForm.vue?vue&type=template&id=08bb9358&scoped=true"
import script from "./SaleEditMultiStudentsForm.vue?vue&type=script&lang=js"
export * from "./SaleEditMultiStudentsForm.vue?vue&type=script&lang=js"
import style0 from "./SaleEditMultiStudentsForm.vue?vue&type=style&index=0&id=08bb9358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb9358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VSimpleTable,VTextarea})
